import {GoingUtils, AssertUtils, CommonException} from "goingutils";


class GoMenuDrop {
    //构造函数
    constructor(options) {
        //如果没有传入styles 则设置默认的样式
        if (options["styles"] == null) {
            options["styles"] = {};
            options["styles"]["left"] = 0;
            options["styles"]["top"] = 0;
        } else {
            //如果没有传入left 则设置为0
            if (options["styles"]["left"] == null) {
                options["styles"]["left"] = 0;
            }
            //如果没有设置top 则设置为0
            if (options["styles"]["top"] == null) {
                options["styles"]["top"] = 0;
            }
        }
        this.targetEl = options["targetEl"];
        this.clickFun = options["clickFun"] || function () {
        };
        //如果没有传入 targetEl 则抛出异常
        if (!AssertUtils.isNotNull(this.targetEl)) {
            throw new CommonException("targetEl is can not empty", 1);
        }
        //如果传入了elId 则采用传入的id来创建 如果没有传入 则随机生成
        this.elId = options["elId"] || GoingUtils.getUUid(12);
        //获取下拉的数据项
        this.elItems = options["items"];
        //判断传入的this.elItems是不是数组 一定需要传入数组
        if (!AssertUtils.isArray(this.elItems)) {
            throw new CommonException("elItems is  not Array", 1);
        }
        //创建或者是显示浮动菜单
        this.createMenu(options);
        return this;
    }

    destory() {
        this.elItems = null;
        this.targetEl = null;
    }

    _addElEvent(selDiv) {
        //当鼠标移入时 则设置显示标志为true
        selDiv.addEventListener("mouseover", function () {
            selDiv.setAttribute("sonDisp", "true");
        });
        //当鼠标移开时 延迟200毫秒 则判断显示标志是否为false 如果为false则进行隐藏 因为可能鼠标会移入到父节点
        selDiv.addEventListener("mouseleave", function (event) {
            var elId = event.target.getAttribute("id");
            selDiv.setAttribute("sonDisp", "false");

            window.setTime = setTimeout(function () {
                let _selDivObj = document.getElementById(elId);
                var parentDisp = _selDivObj.getAttribute("parentDisp");
                var sonDisp = _selDivObj.getAttribute("sonDisp");
                if (parentDisp != "true" && sonDisp != "true") {
                    _selDivObj.style.display = "none";
                    _selDivObj.setAttribute("parentDisp", "false");
                    _selDivObj.setAttribute("sonDisp", "false");
                }
                window.clearTimeout(window.setTime);
            }, 300);
        });
    }

    //添加菜单列表
    _appendUlAndLi(selDiv, options) {
        var ulObj = document.createElement("ul");
        //循环添加菜单下拉子项信息
        this.elItems.forEach(function ({name, id}) {
            var liObj = document.createElement("li");
            liObj.className = "dropItem";
            liObj.id = id;
            liObj.setAttribute("name", name);
            liObj.innerText = name;
            if (
                options["styles"] != null &&
                options["styles"]["paddingLeft"] != null
            ) {
                liObj.style.paddingLeft = options["styles"]["paddingLeft"];
            }
            ulObj.appendChild(liObj);
        });
        //选中菜单子项时 执行点击事件
        this._addUlEvent(ulObj);
        selDiv.appendChild(ulObj);
    }

    //选中菜单子项时 执行点击事件
    _addUlEvent(ulObj) {
        var menuObj = this;
        //注册点击子项的事件
        ulObj.addEventListener("click", function (event) {
            menuObj.clickFun(
                event.target.getAttribute("id"),
                event.target.getAttribute("name")
            );
            let selDivObj = document.getElementById(menuObj.elId);
            selDivObj.style.display = "none";
        });
    }

    //创建菜单元素
    _createMenuEl(options) {
        let {x, y} = GoingUtils.getElementPosition(this.targetEl);
        //如果传入了template 则通过template元素来初始化内容
        if (options["template"] != undefined) {
            //获取模板内容 并移除该节点
            let tempObj = document.getElementById(options["template"]);
            if (tempObj != null) {
                let htmls = tempObj.innerHTML;
                var frag = document.createDocumentFragment();
                var selDiv = document.createElement("div");
                selDiv.id = this.elId;
                selDiv.className = "goingFloatDrop";
                selDiv.style.left = x + parseFloat(options["styles"]["left"]) + "px";
                selDiv.style.top = y + parseFloat(options["styles"]["top"]) + 30 + "px";
                selDiv.setAttribute("parentDisp", "true");
                selDiv.style.zIndex = GoingUtils.getCurMaxZIndex();
                selDiv.innerHTML = htmls;
                //将元素添加到。contentBody中
                if (selDiv.querySelector(".contentBody") != null) {
                    this._appendUlAndLi(selDiv.querySelector(".contentBody"), options);
                } else {
                    var exception = new CommonException(
                        "template容器中必须包含contentBody",
                        1
                    );
                    throw exception;
                }
                frag.appendChild(selDiv);
                document.body.appendChild(frag);
                this._addElEvent(selDiv);
                tempObj.remove();
            }
        } else {
            let frag = document.createDocumentFragment();
            let selDiv = document.createElement("div");
            selDiv.id = this.elId;
            selDiv.className = "goingFloatDrop";
            selDiv.style.width = options["width"] + "px" || "100px";

            selDiv.style.zIndex = GoingUtils.getCurMaxZIndex();
            //如果显示的位置超出了屏幕的高度，则向上显示
            selDiv.style.left = x + "px";
            if (y + this.elItems.length * 26 > $(window).height()) {
                selDiv.style.top = y - this.elItems.length * 26 + 10 + "px";
            } else {
                selDiv.style.top = y + 30 + "px";
            }

            selDiv.setAttribute("parentDisp", "true");
            this._appendUlAndLi(selDiv, options);
            this._addElEvent(selDiv);
            frag.appendChild(selDiv);
            document.body.appendChild(frag);
        }
    }

    //创建菜单下拉
    createMenu(options) {
        let selDivObj = document.getElementById(this.elId);
        if (selDivObj == null) {
            this._createMenuEl(options);
        } else {
            this.show(selDivObj, options);
        }
    }

    //隐藏菜单
    hide() {
        window.clearTimeout(window.setTime2);
        let menuObj = this;
        let selDivObj = document.getElementById(this.elId);
        selDivObj.setAttribute("parentDisp", "false");
        //如果移开时 延迟200毫秒 则判断sonDisp显示标志是否为false 如果false则表示移入的焦点不在i18nSelDrop对象 如果为true 则表示移入到i18nSelDrop对象了
        window.setTime2 = setTimeout(function () {
            let _selDivObj = document.getElementById(menuObj.elId);
            var sonDisp = _selDivObj.getAttribute("sonDisp");
            var parentDisp = _selDivObj.getAttribute("parentDisp");
            if (parentDisp != "true" && sonDisp != "true") {
                _selDivObj.style.display = "none";
                _selDivObj.setAttribute("parentDisp", "false");
                _selDivObj.setAttribute("sonDisp", "false");
            }
            _selDivObj = null;
            window.clearTimeout(window.setTime2);
        }, 300);
    }

    show(selDivObj, options) {
        //如果为空则重新获取下对象 如果不为空则直接显示
        if (!AssertUtils.isNotNull(selDivObj)) {
            selDivObj = document.getElementById(this.elId);
        }
        selDivObj.setAttribute("parentDisp", "true");
        selDivObj.style.display = "block";
        let {x, y} = GoingUtils.getElementPosition(this.targetEl);

        if (y + this.elItems.length * 26 > ($(window)).height()) {
            selDivObj.style.top = y - this.elItems.length * 26 + 10 + "px";
        } else {
            selDivObj.style.top = y + 30 + "px";
        }
        selDivObj.style.left = x + parseFloat(options["styles"]["left"]) + "px";
    }
}

export default GoMenuDrop;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/GoMenuDrop.js